export function truncate(str, n) {
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
}

const truncatePlugin = {
  install(app) {
    app.config.globalProperties.$truncate = truncate;
  },
};

export default truncatePlugin;
